import React from 'react';
import TextTruncate from 'react-text-truncate';
import Avatar from '../Avatar';
import styles from './styles.sass';

export default function AvatarWithNameAndBio({
  bio,
  imageUrl,
  name,
  userId,
  nameContainerClassName,
}) {
  return (
    <div className={styles.stationCreator}>
      <div className={styles.stationCreatorInner}>
        <span
          className={`${styles.stationCreatorAvatar} ${
            bio ? styles.stationCreatorAvatarWithBio : ''
          }`}
        >
          <Avatar size={80} src={imageUrl} userId={userId} />
        </span>
        <span className={styles.stationCreatorName}>
          <span className={nameContainerClassName && nameContainerClassName}>
            {name}
          </span>
          <TextTruncate
            containerClassName={`${
              styles.stationCreatorNameTruncated
            } ${nameContainerClassName || ''}`}
            line={1}
            truncateText="…"
            text={name}
          />
          {bio && <p>{bio}</p>}
        </span>
      </div>
    </div>
  );
}
